// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"33a8e09f","297":"8ac12694","643":"5feb25fa"}[chunkId] + ".chunk.js";
};